module.exports = __webpack_public_path__ + "img/circle.6506a9ce.png";